import React, { useState, useEffect, useRef } from "react";
import Card from "../assets/CardArrow.svg";
import Card2 from "../assets/CardArrow2.svg";
import IconContainer from "../assets/IconContainer.svg";
import AgioIcon from "../assets/LegendsLeagueLogo.svg";
import Vs from "../assets/VsWhiteIcon.svg";
import Colors from "../config/Colors";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { isMobile } from "../types/type";
interface CardArrowProps {
  children?: React.ReactNode;
  marginBottom?: string | number;
  vs?: boolean;
  timer?: boolean;
  onFirstTimerEnd?: () => void;
  onSecondTimerEnd?: () => void;
  onThirdTimerEnd?: () => void;
  selected?: number;
  ajioIconWidth?: string | number;
  ajioIconHeight?: string | number;
  startTime?: number;
  startRound?: number;
  onLogoClick?: () => void;
}

function CardArrow({
  children,
  marginBottom,
  vs,
  timer,
  onFirstTimerEnd,
  onSecondTimerEnd,
  onThirdTimerEnd,
  selected,
  ajioIconHeight,
  ajioIconWidth,
  startRound = 0,
  startTime = 20,
  onLogoClick,
}: CardArrowProps) {
  const numberOfSeconds = 20;
  const [time, setTime] = useState(startTime);
  const [round, setRound] = useState(startRound);
  const [audio] = useState(new Audio("tick2.mp3"));
  const ref1 = useRef();
  const ref2 = useRef();

  useEffect(() => {
    if (selected === 1 && round === 0) {
      setTime(numberOfSeconds);
      setRound(1);
    } else if (selected === 2 && round === 1) {
      setTime(numberOfSeconds);
      setRound(2);
    } else if (selected === 3 && round === 2) {
      setTime(0);
      if (onThirdTimerEnd) {
        onThirdTimerEnd();
      }
    }
  }, [selected, numberOfSeconds, onThirdTimerEnd]);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (timer && time > 0) {
      interval = setInterval(() => {
        audio.play();
        setTime(time - 1);
      }, 1000);
    } else if (timer && time === 0) {
      if (round < 2) {
        setTimeout(() => {
          setTime(numberOfSeconds);
          setRound((prevRound) => prevRound + 1); // update round after the timer has finished
          if (round === 0 && onFirstTimerEnd) {
            onFirstTimerEnd();
          } else if (round === 1 && onSecondTimerEnd) {
            onSecondTimerEnd();
          }
        }, 2000);
      } else {
        setRound(3);
        if (onThirdTimerEnd) {
          onThirdTimerEnd();
        }
      }
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [
    timer,
    time,
    round,
    numberOfSeconds,
    selected,
    onFirstTimerEnd,
    onSecondTimerEnd,
    onThirdTimerEnd,
  ]);

  const progress = Math.round((time / numberOfSeconds) * 100);

  const handleLogoClick = () => {
    onLogoClick && onLogoClick();
  };

  return (
    <div className="otherCardArrowContainer relative" style={{ marginBottom }}>
      <div className="pageHeaderDropdowIconContainerHorizontal">
        <div className="pageHeaderDropdowIconContainerCircle">
          {(vs || timer) && (
            <img
              src={IconContainer}
              alt=""
              className={"pageHeaderDropdowIconContainer "}
            />
          )}
          {vs ? (
            <img src={Vs} alt="vs" className="pageHeaderDropdowIconVs" />
          ) : (
            <>
              {timer ? (
                <div className="otherTimerContainer">
                  <CircularProgressbar
                    value={progress}
                    text={time.toString()}
                    strokeWidth={10}
                    styles={buildStyles({
                      strokeLinecap: "butt",
                      textSize: "32px",
                      pathTransitionDuration: 0.5,
                      pathColor: "#CBE1FC",
                      textColor: Colors.white,
                      trailColor: Colors.primary,
                    })}
                  />
                </div>
              ) : (
                <img
                  src={AgioIcon}
                  onClick={handleLogoClick}
                  alt="ajio"
                  className={`pageHeaderDropdowIcon pointer`}
                  style={{
                    width: ajioIconWidth || (isMobile ? 150 : 160),
                    height: ajioIconHeight || (isMobile ? 150 : 160),
                  }}
                />
              )}
            </>
          )}
        </div>
      </div>
      <img src={Card} alt="" className="otherCardArrowImage" />
      <img src={Card2} alt="" className="otherCardArrowImageDesktop" />
      {children}
    </div>
  );
}

export default CardArrow;
